(() => {
var $c734c75d8a1eae7e$export$3be962be852346df = /** @class */ function() {
    function MerCalculator() {
        this.TRANSLATIONS_EN = {
            Weight: "Weight",
            Age: "Age",
            "0-4 months": "0-4 months",
            "4-9 months": "4-9 months",
            "9-12 months": "9-12 months",
            ">12 months": ">12 months",
            Activity: "Activity",
            Active: "Active",
            "Not Active/Indoor Cat": "Not Active/Indoor Cat",
            Peculiarities: "Peculiarities",
            None: "None",
            Neutered: "Neutered",
            Gestating: "Gestating",
            Lactating: "Lactating",
            "Number of Kittens": "Number of Kittens",
            "Recommended calories": "Recommended calories",
            "Week of lactation": "Week of lactation",
            "Weeks 1-2": "Weeks 1-2",
            "Weeks 3-4": "Weeks 3-4",
            "Week 5": "Week 5",
            "Week 6": "Week 6",
            "Week 7": "Week 7"
        };
    }
    /**
     * Calculates the daily energy requirements for a queen cat based on her weight, gestation period, lactation period, and number of kittens
     * @param {number} weight - The weight of the queen cat in kilograms
     * @param {boolean} gestation - Whether or not the queen cat is in gestation (true or false). If false, cat is in Lactation
     * @param {number} numberKittens - The number of kittens the queen cat is lactating
     * @param {number} lactationWeek - The week of lactation
     * @returns {number} - The daily energy requirements of the queen cat in kcal
     */ MerCalculator.prototype.calculateQueenEnergy = function(weight, gestation, numberKittens, lactationWeek) {
        if (gestation === void 0) gestation = true;
        if (numberKittens === void 0) numberKittens = 0;
        if (lactationWeek === void 0) lactationWeek = 6;
        var energyRequirement = 0;
        // Calculate the energy requirements during gestation if applicable
        if (gestation) energyRequirement += Math.pow(weight, 0.67) * 140;
        else {
            var l = 1;
            if (lactationWeek <= 2) l = 0.9;
            else if (lactationWeek <= 4) l = 1.2;
            else if (lactationWeek <= 5) l = 1.1;
            else if (lactationWeek <= 6) l = 1;
            else l = 0.8;
            if (numberKittens < 3) energyRequirement += Math.pow(weight, 0.67) * 100 + 18 * weight * l;
            else if (numberKittens >= 3 && numberKittens <= 4) energyRequirement += Math.pow(weight, 0.67) * 100 + 60 * weight * l;
            else if (numberKittens > 4) energyRequirement += Math.pow(weight, 0.67) * 100 + 70 * weight * l;
        }
        return energyRequirement;
    };
    /**
     * Calculates the daily energy requirements for a cat based on its weight, neutered status, indoor lifestyle, and activity level
     * @param {number} weight - The weight of the cat in kilograms
     * @param {boolean} neutered - Whether or not the cat is neutered (true or false)
     * @param {number} age - Age of cats in months, for adult cats (> 12 months) the number does not affect the outcome
     * @param {boolean} isActive - Whether or not the cat is active (true or false) In case of indoor cat use false
     * @returns {number} - The daily energy requirements of the cat in kcal
     */ MerCalculator.prototype.calculateEnergyRequirements = function(weight, age, neutered, isActive) {
        if (neutered === void 0) neutered = true;
        if (isActive === void 0) isActive = true;
        var energyRequirement = 0;
        // Calculate the energy requirements for indoor and/or neutered cats
        if (!isActive || neutered) energyRequirement = Math.pow(weight, 0.67) * 75;
        else energyRequirement = Math.pow(weight, 0.67) * 100;
        if (age < 4) energyRequirement *= 2;
        else if (age < 9) energyRequirement *= 1.75;
        else if (age < 12) energyRequirement *= 1.5;
        return energyRequirement;
    };
    /**
     * Creates and displays a form for calculating the daily energy requirements of a cat.
     * The form allows the user to input the cat's weight, age, activity level, and any peculiarities (e.g., neutered, gestating, lactating).
     * Based on the input values, the function calculates and displays the recommended daily energy requirements for the cat.
     *
     * @param {HTMLElement} element - The HTML element where the form will be displayed.
     * @param {Object} translations - (Optional) An object containing translated text for form labels and messages.
     *                                If not provided, English translations will be used.
     * @param {string|undefined}    - The HTML to display at the footer of the form, default to creditation link
     * @returns {Object} - An object containing references to the form elements for further manipulation, such as retrieving user inputs or updating the displayed recommendations.
     */ MerCalculator.prototype.createCatEnergyForm = function(element, translations, footerHtml) {
        var _this = this;
        if (translations === void 0) translations = undefined;
        if (footerHtml === void 0) footerHtml = 'Cat MER Calculator by <a href="https://huiskatteninfo.nl/software/cat-mer-calculator/en/" target="_blank" class="cat-mer-credits">HuiskattenInfo.nl</a>';
        if (translations === undefined) translations = this.TRANSLATIONS_EN;
        var weightDefault = 4;
        var ageOptions = [
            {
                value: "0-4",
                label: translations["0-4 months"]
            },
            {
                value: "4-9",
                label: translations["4-9 months"]
            },
            {
                value: "9-12",
                label: translations["9-12 months"]
            },
            {
                value: ">12",
                label: translations[">12 months"]
            }
        ];
        var activityOptions = [
            {
                value: "active",
                label: translations["Active"]
            },
            {
                value: "not-active",
                label: translations["Not Active/Indoor Cat"]
            }
        ];
        var peculiaritiesOptions = [
            {
                value: "none",
                label: translations["None"]
            },
            {
                value: "neutered",
                label: translations["Neutered"]
            },
            {
                value: "gestating",
                label: translations["Gestating"]
            },
            {
                value: "lactating",
                label: translations["Lactating"]
            }
        ];
        var LactationWeekOptions = [
            {
                value: "1-2",
                label: translations["Weeks 1-2"]
            },
            {
                value: "3-4",
                label: translations["Weeks 3-4"]
            },
            {
                value: "5",
                label: translations["Week 5"]
            },
            {
                value: "6",
                label: translations["Week 6"]
            },
            {
                value: "7",
                label: translations["Week 7"]
            }
        ];
        // Function to calculate and update the recommended calories
        var updateRecommendedCalories = function() {
            var weight = parseFloat(weightInput.value);
            var age = ageSelect.value;
            var activity = activitySelect.value;
            var peculiarities = peculiaritiesSelect.value;
            var numberKittens = parseInt(numberKittensInput.value);
            var lactationWeek = LactationWeekSelect.value;
            var recommendedCalories = 0;
            if (peculiarities === "lactating") {
                var lactationWeekNr = parseInt(lactationWeek.charAt(0));
                recommendedCalories = _this.calculateQueenEnergy(weight, false, numberKittens, lactationWeekNr);
            } else if (peculiarities === "gestating") recommendedCalories = _this.calculateQueenEnergy(weight, true);
            else {
                // Mapping age options to numbers
                var ageMap = {
                    "0-4": 0,
                    "4-9": 4,
                    "9-12": 9,
                    ">12": 12
                };
                var ageInMonths = ageMap[age];
                recommendedCalories = _this.calculateEnergyRequirements(weight, ageInMonths, peculiarities === "neutered", activity === "active");
            }
            recommendedCaloriesSpan.textContent = recommendedCalories.toFixed(0);
        };
        // Create the weight input field
        var weightDiv = document.createElement("div");
        var weightLabel = document.createElement("label");
        weightLabel.textContent = translations["Weight"] + ": ";
        var weightInput = document.createElement("input");
        weightInput.type = "number";
        weightInput.value = weightDefault + "";
        weightInput.min = "0";
        weightInput.addEventListener("input", updateRecommendedCalories);
        weightDiv.appendChild(weightLabel);
        weightDiv.appendChild(weightInput);
        element.appendChild(weightDiv);
        // Create the age select field
        var ageDiv = document.createElement("div");
        var ageLabel = document.createElement("label");
        ageLabel.textContent = translations["Age"] + ": ";
        var ageSelect = document.createElement("select");
        ageOptions.forEach(function(option) {
            var ageOption = document.createElement("option");
            ageOption.value = option.value;
            ageOption.textContent = option.label;
            ageSelect.appendChild(ageOption);
        });
        ageSelect.addEventListener("change", updateRecommendedCalories);
        ageSelect.value = ">12";
        ageDiv.appendChild(ageLabel);
        ageDiv.appendChild(ageSelect);
        element.appendChild(ageDiv);
        // Create the activity select field
        var activityDiv = document.createElement("div");
        var activityLabel = document.createElement("label");
        activityLabel.textContent = translations["Activity"] + ": ";
        var activitySelect = document.createElement("select");
        activityOptions.forEach(function(option) {
            var activityOption = document.createElement("option");
            activityOption.value = option.value;
            activityOption.textContent = option.label;
            activitySelect.appendChild(activityOption);
        });
        activitySelect.addEventListener("change", updateRecommendedCalories);
        activityDiv.appendChild(activityLabel);
        activityDiv.appendChild(activitySelect);
        activityDiv.appendChild(activitySelect);
        element.appendChild(activityDiv);
        // Create the peculiarities select field
        var peculiaritiesDiv = document.createElement("div");
        var peculiaritiesLabel = document.createElement("label");
        peculiaritiesLabel.textContent = translations["Peculiarities"] + ": ";
        var peculiaritiesSelect = document.createElement("select");
        peculiaritiesOptions.forEach(function(option) {
            var peculiaritiesOption = document.createElement("option");
            peculiaritiesOption.value = option.value;
            peculiaritiesOption.textContent = option.label;
            peculiaritiesSelect.appendChild(peculiaritiesOption);
        });
        peculiaritiesSelect.addEventListener("change", updateRecommendedCalories);
        peculiaritiesDiv.appendChild(peculiaritiesLabel);
        peculiaritiesDiv.appendChild(peculiaritiesSelect);
        element.appendChild(peculiaritiesDiv);
        // Create the number of kittens input field
        var numberKittensDiv = document.createElement("div");
        var numberKittensLabel = document.createElement("label");
        numberKittensLabel.textContent = translations["Number of Kittens"] + ": ";
        var numberKittensInput = document.createElement("input");
        numberKittensInput.type = "number";
        numberKittensInput.value = "4";
        numberKittensInput.min = "1";
        numberKittensInput.addEventListener("input", updateRecommendedCalories);
        numberKittensDiv.appendChild(numberKittensLabel);
        numberKittensDiv.appendChild(numberKittensInput);
        element.appendChild(numberKittensDiv);
        // Create the kitten age select field
        var LactationWeekDiv = document.createElement("div");
        var LactationWeekLabel = document.createElement("label");
        LactationWeekLabel.textContent = translations["Week of lactation"] + ": ";
        var LactationWeekSelect = document.createElement("select");
        LactationWeekOptions.forEach(function(option) {
            var LactationWeekOption = document.createElement("option");
            LactationWeekOption.value = option.value;
            LactationWeekOption.textContent = option.label;
            LactationWeekSelect.appendChild(LactationWeekOption);
        });
        LactationWeekSelect.addEventListener("change", updateRecommendedCalories);
        LactationWeekDiv.appendChild(LactationWeekLabel);
        LactationWeekDiv.appendChild(LactationWeekSelect);
        element.appendChild(LactationWeekDiv);
        // Create the recommended calories display
        var recommendedCaloriesDiv = document.createElement("div");
        var recommendedCaloriesText = document.createElement("span");
        recommendedCaloriesText.textContent = translations["Recommended calories"] + ": ";
        var recommendedCaloriesSpan = document.createElement("span");
        recommendedCaloriesDiv.appendChild(recommendedCaloriesText);
        recommendedCaloriesDiv.appendChild(recommendedCaloriesSpan);
        recommendedCaloriesDiv.append(" Kcal");
        element.appendChild(recommendedCaloriesDiv);
        if (footerHtml) {
            var footerHtmlDiv = document.createElement("div");
            footerHtmlDiv.innerHTML = footerHtml;
            element.appendChild(footerHtmlDiv);
        }
        // show or hide number of kittens and lactation week based on peculiariities
        peculiaritiesSelect.addEventListener("change", function() {
            LactationWeekDiv.hidden = peculiaritiesSelect.value !== "lactating";
            numberKittensDiv.hidden = peculiaritiesSelect.value !== "lactating";
        });
        peculiaritiesSelect.dispatchEvent(new Event("change"));
        // Initialize the recommended calories
        updateRecommendedCalories();
        return {
            weight: weightInput,
            age: ageSelect,
            activity: activitySelect,
            peculiarities: peculiaritiesSelect,
            numberKittens: numberKittensInput,
            LactationWeek: LactationWeekSelect,
            recommendedCalories: recommendedCaloriesSpan
        };
    };
    return MerCalculator;
}();




// Calculator library
const $321955f4bb35163e$var$calculator = new (0, $c734c75d8a1eae7e$export$3be962be852346df)();
// Initialization
document.addEventListener("DOMContentLoaded", ()=>{
    // Calorie calculator forms
    document.querySelectorAll(".calories_calculator").forEach((mainElement)=>{
        const out = $321955f4bb35163e$var$calculator.createCatEnergyForm(mainElement, translations, "");
        out.weight.step = "0.1";
        // resetting and storing values
        const loadFromStorage = ()=>{
            const data = window.localStorage.getItem("calories_data_new");
            let stored = {
                weight: "4",
                age: ">12",
                activity: "active",
                peculiarities: "none",
                numberKittens: "4",
                calories: "" + Math.round($321955f4bb35163e$var$calculator.calculateEnergyRequirements(4, 13, false, true))
            };
            if (data != null) stored = JSON.parse(data);
            out.weight.value = stored.weight;
            out.age.value = stored.age;
            out.activity.value = stored.activity;
            out.peculiarities.value = stored.peculiarities;
            out.peculiarities.dispatchEvent(new Event("change"));
            out.numberKittens.value = stored.numberKittens;
            out.recommendedCalories.innerText = stored.calories;
        };
        const resetLink = document.createElement("a");
        resetLink.textContent = translations["Reset"] || "Reset";
        resetLink.href = "#";
        resetLink.addEventListener("click", (ev)=>{
            window.localStorage.removeItem("calories_data_new");
            loadFromStorage();
            ev.preventDefault();
        });
        mainElement.appendChild(resetLink);
        mainElement.append("\r\n");
        const saveLink = document.createElement("a");
        saveLink.textContent = translations["Save"] || "Save";
        saveLink.href = "#";
        saveLink.addEventListener("click", (ev)=>{
            window.localStorage.setItem("calories_data_new", JSON.stringify({
                weight: out.weight.value,
                age: out.age.value,
                activity: out.activity.value,
                peculiarities: out.peculiarities.value,
                numberKittens: out.numberKittens.value,
                calories: out.recommendedCalories.innerText
            }));
            // @ts-ignore
            ev.target.blur();
            ev.preventDefault();
        });
        mainElement.appendChild(saveLink);
        mainElement.querySelectorAll(".calories_close").forEach((el)=>el.addEventListener("click", (ev)=>{
                // @ts-ignore
                ev.target.blur();
                ev.preventDefault();
            }));
        // Observing changes and applying them to entire page
        function updateGlobals() {
            document.querySelectorAll(".global_calories_recommend").forEach((el)=>el.innerHTML = out.recommendedCalories.innerText + " Kcal");
            document.querySelectorAll(".calories_food_amount").forEach((el)=>el.innerHTML = "" + Math.round(parseInt(out.recommendedCalories.innerText) * 100 / parseInt(el.dataset.cal)));
            document.querySelectorAll(".calories_price_day").forEach((el)=>{
                //console.log(el);
                const price = parseFloat(el.dataset.priceKg) // price in euro per kg
                ;
                const amount = parseInt(out.recommendedCalories.innerText) * 100 / parseInt(el.dataset.cal) // amount in grams
                ;
                el.innerHTML = Intl.NumberFormat(translations["locale"] ?? "en-GB", {
                    style: "currency",
                    currency: "EUR"
                }).format(price * amount / 1000);
            });
        }
        const changeObserver = new MutationObserver(updateGlobals);
        changeObserver.observe(out.recommendedCalories, {
            characterData: true,
            subtree: true,
            childList: true
        });
        document.querySelectorAll(".calories_food_amount").forEach((el)=>changeObserver.observe(el, {
                attributes: true
            }));
        // initial load
        loadFromStorage();
        updateGlobals();
    });
    // find food calorie forms and make them change calories_food_amount when changed
    document.querySelectorAll("#caloriesper100g").forEach((caloriesInput)=>{
        caloriesInput.addEventListener("change", (input)=>{
            // @ts-ignore
            document.querySelectorAll(".calories_food_amount").forEach((el)=>el.dataset.cal = input.target.value);
        });
        caloriesInput.dispatchEvent(new Event("change"));
    });
});

})();
//# sourceMappingURL=hki-mer-calculator.js.map
